module.exports = __webpack_public_path__ + "media/images/emblems/Fehraltorf-blazon-40475a30025ca62a6267f0ae9d08733b.svg";